import {ObjectDescription} from "../../_modules/location/_models/_enums/object-description";
import {BusinessCaseType} from "../../_modules/location/_models/_enums/business-case-type";

/**
 * The qualifier (`ObjectDescription`, the DSFinV-K `GV_NAME`) a Geldtransit is recorded under, decided by the
 * direction of the money (#820): out of the drawer `Skimming` („Abschöpfung"), into it `Deposit` („Einlage").
 *
 * Mirrors `Shared.Core/Calculation/GeldtransitPolicy.cs`, which the server applies to every posting whatever a
 * client sent; the web sends the same so the screen and the receipt agree. DSFinV-K 2.4 leaves `GV_NAME` to
 * the register (Tz. 4.1.4, p. 34) and defines the type itself as „Entnahme / Einlage von Bargeld" (Anhang C,
 * p. 58). Until #820 every close posted `Skimming` in both directions.
 */
export class GeldtransitPolicy {
  static applies(type: BusinessCaseType): boolean {
    return type === BusinessCaseType.Geldtransit;
  }

  /**
   * The qualifier for a transit whose signed money is `signedAmount` (positive = into the drawer, negative =
   * out of it). Zero answers `Skimming`, the value every transit carried before #820.
   */
  static qualifierFor(signedAmount: number): ObjectDescription {
    return signedAmount > 0 ? ObjectDescription.Deposit : ObjectDescription.Skimming;
  }
}
